import { render, staticRenderFns } from "./CertificateReference.vue?vue&type=template&id=12c2caa4&scoped=true"
import script from "./CertificateReference.vue?vue&type=script&lang=js"
export * from "./CertificateReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2caa4",
  null
  
)

export default component.exports